export default __webpack_public_path__ + "static/media/ic_cost.68bcbb9d.svg";